export default function buildPipelineNamesByWritekey(pipelines) {
  if (!pipelines) {
    return {};
  }

  const pipelineNamesByWritekey = pipelines.reduce(
    (namesByWritekey, { writekey, name }) => ({
      ...namesByWritekey,
      [writekey]: name,
    }),
    {}
  );

  return pipelineNamesByWritekey;
}
